import { useMemo } from 'react'
import { getAllNodeVarsFromNode } from '../utils'
import { useTypedReactFlow } from './use-react-flow'

/**
 * Hook to get all nodevars from all nodes in the current flow
 * This collects nodevars from all nodes, including leaf nodes
 * @returns Array of unique nodevars from all nodes in the flow
 */
export const useAllNodeVars = () => {
  const { getNodes } = useTypedReactFlow()

  return useMemo(() => {
    const nodes = getNodes()

    // Collect all nodevars from all nodes (including leaf nodes)
    const nodevars: string[] = []
    nodes.forEach((node) => {
      const nodeVars = getAllNodeVarsFromNode(node)
      nodevars.push(...nodeVars)
    })

    // Remove duplicates and return
    return [...new Set(nodevars)]
  }, [getNodes])
}
